import { BeatLoader } from 'react-spinners';

function LoadingSpinner() {
    return (
        <div className="flex items-center justify-center">
            <BeatLoader color="#f3f4f6" loading={true} size={13} margin={2} />
        </div>
    );
}

export { LoadingSpinner };
